<div class="main-painel">
    <div class="title-panel">
        Consulta de Dados
    </div>
    <mat-divider></mat-divider>
    <div class="info">
        Buscar Dados de Tabelas do Banco dados Sankhya
    </div>
    <mat-divider></mat-divider>
        <div class="query-configuration">
            <ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" name='sankhyaquery'>
            </ngx-spinner>
            <div class="more-options">
                <mat-form-field  class="no-padding-form-field-5px full-width" >
                    <mat-label>Tipo de Busca</mat-label>
                    <mat-select [(ngModel)]="typeSelected" disabled>
                    <mat-option *ngFor="let item of type" [value]="item.type">
                        {{item.name}}
                    </mat-option>
                    </mat-select>
                </mat-form-field>
                <div fxFlex></div>
                <mat-slide-toggle   [(ngModel)]="useVariable"  [ngModelOptions]="{standalone: true}" (change)="onToggleChange()">Usar Variável
                </mat-slide-toggle>
                <mat-divider vertical="true"></mat-divider>
                <button mat-raised-button color="primary" (click)="executeQuery()">Executar</button>
            </div>
            <mat-divider></mat-divider>
            <div class="body-container">
                <div class="fields-options" *ngIf="typeSelected == 4 && !useVariable">
                    <mat-form-field  appearance="outline" class="no-padding-form-field-5px full-width">
                        <mat-label>Nome da View</mat-label>
                        <input  tabindex="1" type = "text" matInput  [(ngModel)]="viewname" placeholder="Nome da View. Ex: VW_NOMEDAVIEW"  required #inpName  (ngModelChangeDebounced)="ngModelChange($event)"> 
                        <button    tabindex="-1"  type="button" *ngIf="inpName.value" matSuffix mat-icon-button aria-label="Clear"  (click)="inpName.value=''" >
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-form-field  appearance="outline" class="no-padding-form-field-5px full-width">
                        <mat-label>Campos da View</mat-label>
                        <input  tabindex="1" type = "text" matInput [(ngModel)]="campo" placeholder="Nome dos Campos. Ex: CAMPOA,CAMPOB"  required #inpCampo  (ngModelChangeDebounced)="ngModelChange($event)"> 
                        <button    tabindex="-1" type="button" *ngIf="inpCampo.value" matSuffix mat-icon-button aria-label="Clear"  (click)="inpCampo.value=''" >
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-form-field  appearance="outline" class="no-padding-form-field-5px full-width">
                        <mat-label>Condição da View</mat-label>
                        <input  tabindex="1" type = "text" matInput [(ngModel)]="condicao"  placeholder="Nome dos Campos. Ex: WHERE CAMPOA=XXX"  required #inpCondicao  (ngModelChangeDebounced)="ngModelChange($event)"> 
                        <button    tabindex="-1" type="button" *ngIf="inpCondicao.value" matSuffix mat-icon-button aria-label="Clear"  (click)="inpCondicao.value=''" >
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                <div class="fields-options" *ngIf="typeSelected == 5 || useVariable">
                    <div class="query-text">
                        <mat-form-field appearance="outline" ngClass="customtextarea no-padding-form-field fill-container" >
                            <mat-label>Consulta</mat-label>
                            <textarea  matInput type="text"  #value required  [(ngModel)]="query" (ngModelChangeDebounced)="ngModelChange($event)">
                            </textarea>
                        </mat-form-field>
                    </div>                        
                </div>
                
                
                <div class="query-result">
                    <ag-grid-angular
                        style="width: 100%; height: 100%"
                        [class]="(ThemeService.theme)? 'ag-theme-quartz-dark':'ag-theme-quartz'"
                        [rowData]="rows"
                        [columnDefs]="displayedColumns"
                        (gridReady)="onGridReady($event)"
                        overlayNoRowsTemplate="Não encontrado nenhum resultado"
                        rowBuffer="150"
                        rowSelection="multiple"
                        cacheBlockSize= "100"
                        cacheOverflowSize="2"
                        maxBlocksInCache= 10
                        [pagination]="false"
                        [localeText]="ls.getCurrentGridLocale()"
                        [multiSortKey]="true">
                    </ag-grid-angular>
                </div>
            </div>
        </div>    
</div>